import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var goldCoin = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  viewBox: "0 0 15.877 16",
  children: /*#__PURE__*/_jsx("g", {
    id: "Currency",
    transform: "translate(-11.11 0.13)",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Dollar",
      transform: "translate(11.11 -0.13)",
      children: [/*#__PURE__*/_jsxs("g", {
        id: "Coin",
        transform: "translate(0 0)",
        children: [/*#__PURE__*/_jsxs("g", {
          id: "Bottom",
          transform: "translate(0 0)",
          children: [/*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1797",
            "data-name": "Ellipse 1797",
            cx: "7.5",
            cy: "8",
            rx: "7.5",
            ry: "8",
            transform: "translate(0.877 0)",
            fill: "#e88102"
          }), /*#__PURE__*/_jsx("circle", {
            id: "Ellipse_1798",
            "data-name": "Ellipse 1798",
            cx: "7.538",
            cy: "7.538",
            r: "7.538",
            transform: "translate(0 0.092)",
            fill: "#fdd835"
          })]
        }), /*#__PURE__*/_jsxs("g", {
          id: "Shade",
          transform: "translate(0 0.092)",
          children: [/*#__PURE__*/_jsx("path", {
            id: "Path_7320",
            "data-name": "Path 7320",
            d: "M24.725,1.206,14.8,11.125a7.457,7.457,0,0,1-.6-2.456L22.266.6a7.576,7.576,0,0,1,2.459.606Z",
            transform: "translate(-14.178 -0.581)",
            fill: "#fff",
            opacity: "0.5"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_7321",
            "data-name": "Path 7321",
            d: "M93.492,69.725,83.225,79.992A7.524,7.524,0,0,1,81.5,78.655L92.158,68A7.532,7.532,0,0,1,93.492,69.725Z",
            transform: "translate(-79.386 -65.886)",
            fill: "#fff",
            opacity: "0.5"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_7322",
            "data-name": "Path 7322",
            d: "M68.5,44.269,57.869,54.9c-.165-.193-.323-.395-.469-.6L67.9,43.8c.208.146.41.3.6.469Z",
            transform: "translate(-56.035 -42.439)",
            fill: "#fff",
            opacity: "0.5"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_7323",
            "data-name": "Path 7323",
            d: "M179.393,156.711l-9.182,9.182a7.929,7.929,0,0,1-.811-.258l9.735-9.735A7.95,7.95,0,0,1,179.393,156.711Z",
            transform: "translate(-164.554 -151.054)",
            fill: "#fff",
            opacity: "0.5"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_7324",
            "data-name": "Path 7324",
            d: "M28.575,7.538c0,.053,0,.1,0,.155a7.536,7.536,0,0,0-15.069,0c0-.053,0-.1,0-.155a7.538,7.538,0,0,1,15.075,0Z",
            transform: "translate(-13.5)",
            fill: "#fff",
            opacity: "0.5"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_7325",
            "data-name": "Path 7325",
            d: "M126.959,128.01a5.906,5.906,0,0,1-10.459,3.761A5.906,5.906,0,0,0,125.39,124,5.892,5.892,0,0,1,126.959,128.01Z",
            transform: "translate(-113.298 -120.146)",
            fill: "#fff",
            opacity: "0.5"
          })]
        }), /*#__PURE__*/_jsxs("g", {
          id: "Top",
          transform: "translate(1.812 1.89)",
          children: [/*#__PURE__*/_jsx("circle", {
            id: "Ellipse_1799",
            "data-name": "Ellipse 1799",
            cx: "5.5",
            cy: "5.5",
            r: "5.5",
            transform: "translate(0.063 0.11)",
            fill: "#f39e09"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_7326",
            "data-name": "Path 7326",
            d: "M75.976,56.971a5.676,5.676,0,0,0-8,8,5.676,5.676,0,1,1,8-8Z",
            transform: "translate(-65.93 -54.905)",
            fill: "#e88102"
          })]
        })]
      }), /*#__PURE__*/_jsxs("g", {
        id: "Icon",
        transform: "translate(2.238 2.392)",
        children: [/*#__PURE__*/_jsx("path", {
          id: "Path_7337",
          "data-name": "Path 7337",
          d: "M7.235-182.446v-.8l.715-.14v-4.8l-.715-.14v-.809h3.173a3.316,3.316,0,0,1,1.324.24,1.887,1.887,0,0,1,.849.686,1.89,1.89,0,0,1,.3,1.069,1.926,1.926,0,0,1-.295,1.053,2.046,2.046,0,0,1-.818.732,2.644,2.644,0,0,1-1.209.269l-1.263,0v1.7l.715.14v.8Zm4.307,0-1.126-2.891,1.212-.3.976,2.253.569.131v.806Zm-2.249-3.678h1.092a1.31,1.31,0,0,0,.868-.246.886.886,0,0,0,.288-.714.992.992,0,0,0-.286-.744,1.167,1.167,0,0,0-.846-.278H9.292Z",
          transform: "translate(-4.775 191.214)",
          fill: "#fdd835"
        }), /*#__PURE__*/_jsx("g", {
          id: "Shade-2",
          children: /*#__PURE__*/_jsx("path", {
            id: "Path_7336",
            "data-name": "Path 7336",
            d: "M96.211,77.024a14.117,14.117,0,0,0-8.4,8.038c-.131-.1-.258-.2-.382-.3a5.9,5.9,0,0,1,8.327-8.327A6.381,6.381,0,0,1,96.211,77.024Z",
            transform: "translate(-86 -75)",
            fill: "#fff",
            opacity: "0.25"
          })
        })]
      })]
    })
  })
});
export var ticket = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  children: /*#__PURE__*/_jsx("path", {
    id: "Path_7102",
    "data-name": "Path 7102",
    d: "M11.2,1.2a10,10,0,1,0,10,10A10,10,0,0,0,11.2,1.2Zm0,1.21A8.683,8.683,0,0,1,16.869,4.5l-2.42,2.4a5.351,5.351,0,0,0-6.5,0L5.531,4.5A8.768,8.768,0,0,1,11.2,2.41Zm4.172,8.79A4.172,4.172,0,1,1,11.2,7.028,4.176,4.176,0,0,1,15.372,11.2ZM2.41,11.2A8.668,8.668,0,0,1,4.655,5.356l2.4,2.4a5.368,5.368,0,0,0-.143,6.688L4.5,16.869A8.768,8.768,0,0,1,2.41,11.2Zm8.79,8.79a8.668,8.668,0,0,1-5.844-2.245l2.4-2.4a5.383,5.383,0,0,0,6.879,0l2.4,2.4A8.746,8.746,0,0,1,11.2,19.99Zm6.7-3.121-2.4-2.42A5.4,5.4,0,0,0,16.6,11.2a5.321,5.321,0,0,0-1.242-3.439l2.4-2.4A8.776,8.776,0,0,1,20.006,11.2,8.868,8.868,0,0,1,17.9,16.869Z",
    transform: "translate(-1.2 -1.2)",
    fill: "#4652a4"
  })
});
export var load = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "8",
  viewBox: "0 0 9 8",
  children: /*#__PURE__*/_jsxs("g", {
    id: "Group_11001",
    "data-name": "Group 11001",
    transform: "translate(-630 -1255)",
    children: [/*#__PURE__*/_jsx("rect", {
      id: "Rectangle_17098",
      "data-name": "Rectangle 17098",
      width: "1",
      height: "8",
      rx: "0.5",
      transform: "translate(630 1255)",
      fill: "#908f95"
    }), /*#__PURE__*/_jsx("rect", {
      id: "Rectangle_17099",
      "data-name": "Rectangle 17099",
      width: "1",
      height: "5",
      rx: "0.5",
      transform: "translate(634 1258)",
      fill: "#908f95"
    }), /*#__PURE__*/_jsx("rect", {
      id: "Rectangle_17100",
      "data-name": "Rectangle 17100",
      width: "1",
      height: "6",
      rx: "0.5",
      transform: "translate(638 1255)",
      fill: "#908f95"
    })]
  })
});